import { Link } from "react-router-dom";
import { ShieldCheck, AlertTriangle, Flag } from "lucide-react";
import { Logo } from "@/components/Logo";
import { InstallButton } from "@/components/InstallPWA";

const INFO_LINKS = [
  ["Algemene voorwaarden", "/voorwaarden"],
  ["Privacybeleid", "/privacy"],
  ["Cookies", "/cookies"],
];
const HELP_LINKS = [
  ["Veilig handelen", "/veilig-handelen"],
  ["Veelgestelde vragen", "/faq"],
  ["Contact", "/contact"],
];
const ACCOUNT_LINKS = [
  ["Inloggen", "/inloggen"],
  ["Registreren", "/registreren"],
  ["Plaats advertentie", "/plaatsen"],
];

export function Footer() {
  return (
    <footer className="mt-16 border-t border-[#333] bg-[#0d0d0d] pb-24 pt-10 md:pb-10">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        {/* Safety */}
        <div className="mb-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
          <Safety icon={ShieldCheck} text="Controleer altijd het product én de verkoper voordat je betaalt." />
          <Safety icon={AlertTriangle} text="Betaal nooit buiten een ondersteunde betaalmethode om." />
          <Safety icon={Flag} text="Meld verdachte advertenties of gebruikers direct bij ons." />
        </div>

        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Logo />
            <p className="mt-3 max-w-xs text-sm text-[#A0A0A0]">Eenvoudig kopen. Eenvoudig verkopen.</p>
            <InstallButton variant="ghost" className="mt-4 w-fit" />
          </div>
          <FooterCol title="Informatie" links={INFO_LINKS} />
          <FooterCol title="Hulp" links={HELP_LINKS} />
          <FooterCol title="Account" links={ACCOUNT_LINKS} />
        </div>

        <div className="mt-8 border-t border-[#222] pt-6 text-sm text-[#777]">
          © {new Date().getFullYear()} VRIJMARKT · Koop. Verkoop. Simpel. ·{" "}
          <a href="mailto:info@vrijmarkt.store" className="hover:text-[#FF6A00]">info@vrijmarkt.store</a>
        </div>
      </div>
    </footer>
  );
}

function Safety({ icon: Icon, text }) {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-[#333] bg-[#1c1c1c] p-4">
      <Icon className="h-5 w-5 shrink-0 text-[#FF6A00]" />
      <p className="text-sm text-[#cfcfcf]">{text}</p>
    </div>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="mb-3 font-display text-sm tracking-wide text-[#F5F5F5]">{title.toUpperCase()}</p>
      <ul className="space-y-2">
        {links.map(([label, to]) => (
          <li key={to}><Link to={to} className="text-sm text-[#A0A0A0] transition-colors hover:text-[#FF6A00]">{label}</Link></li>
        ))}
      </ul>
    </div>
  );
}
